import { render, staticRenderFns } from "./OrderInfoSupportingDocuments.vue?vue&type=template&id=423b916e&"
import script from "./OrderInfoSupportingDocuments.vue?vue&type=script&lang=js&"
export * from "./OrderInfoSupportingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports